import { AxiosResponse } from 'axios'
import { queryOptions } from '@tanstack/react-query'
import { createUrl } from './helpers'
import axiosAuth from './config'
import { NSocietyContacts } from '../interfaces/services/society-contacts.interface'

export const getContactsPerSociety = (
  societyId: string
): Promise<AxiosResponse<NSocietyContacts.NGetPerSocieties.IResponse>> => {
  return axiosAuth.get<NSocietyContacts.NGetPerSocieties.IResponse>(
    createUrl(`/society-contacts/get-per-society/${societyId}`)
  )
}

export const getContact = (
  id: string
): Promise<AxiosResponse<NSocietyContacts.NGetById.IResponse>> => {
  return axiosAuth.get<NSocietyContacts.NGetById.IResponse>(
    createUrl(`/society-contacts/contact/${id}`)
  )
}

export const patchContact = (params: {
  id: string
  body: NSocietyContacts.NPatch.IRequestBody
}): Promise<AxiosResponse<NSocietyContacts.NPatch.IResponse>> => {
  return axiosAuth.patch<NSocietyContacts.NPatch.IResponse>(
    createUrl(`/society-contacts/contact/${params.id}`),
    params.body
  )
}

export const createContact = (
  body: NSocietyContacts.NCreate.IRequestBody
): Promise<AxiosResponse<NSocietyContacts.NCreate.IResponse>> => {
  return axiosAuth.post<NSocietyContacts.NCreate.IResponse>(
    createUrl(`/society-contacts/contact`),
    body
  )
}

export const deleteContact = (
  id: string
): Promise<AxiosResponse<NSocietyContacts.NDel.IResponse>> => {
  return axiosAuth.delete<NSocietyContacts.NDel.IResponse>(
    createUrl(`/society-contacts/contact/${id}`)
  )
}

export const contactQueries = {
  getContact: (societyContactId: string) =>
    queryOptions({
      queryKey: [
        { scope: 'societyContact', entity: 'detail', societyContactId },
      ],
      queryFn: async ({ queryKey }) => {
        return (await getContact(queryKey[0].societyContactId)).data.data
      },
      enabled: !!societyContactId,
    }),
  getContactsPerSociety: (societyId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'societyContact', entity: 'detail', societyId }],
      queryFn: async ({ queryKey }) => {
        return (await getContactsPerSociety(queryKey[0].societyId!)).data.data
      },
      enabled: !!societyId,
    }),
}
